import {
  Book,
  CornerDownRight,
  Delete,
  Edit3,
  Feather,
  FileText,
  FolderPlus,
  Search,
  Wrench,
  type LucideIcon,
} from 'lucide-react';
import { HIGHLIGHTERS, Highlighter } from './paper';

export interface ToolStyle {
  label: string;
  icon: LucideIcon;
  tone: Highlighter;
}

/** Each assistant tool gets a verb, an icon and its own highlighter (mobile's tool-style.ts). */
const TOOLS: Record<string, ToolStyle> = {
  search_notes: { label: 'Searching notes', icon: Search, tone: HIGHLIGHTERS.sky },
  list_notes: { label: 'Flipping through notes', icon: FileText, tone: HIGHLIGHTERS.mint },
  get_note_details: { label: 'Reading notes', icon: FileText, tone: HIGHLIGHTERS.mint },
  list_collections: { label: 'Checking notebooks', icon: Book, tone: HIGHLIGHTERS.yellow },
  get_collection_details: { label: 'Opening notebooks', icon: Book, tone: HIGHLIGHTERS.yellow },
  create_collection: { label: 'Starting a notebook', icon: FolderPlus, tone: HIGHLIGHTERS.pink },
  move_note_to_collection: { label: 'Filing note', icon: CornerDownRight, tone: HIGHLIGHTERS.coral },
  title_thread: { label: 'Naming this chat', icon: Edit3, tone: HIGHLIGHTERS.lilac },
  annotate_note: { label: 'Jotting a margin note', icon: Feather, tone: HIGHLIGHTERS.yellow },
  remove_note_annotations: { label: 'Erasing a margin note', icon: Delete, tone: HIGHLIGHTERS.pink },
};

/** Display style for a tool call; unknown tools get a humanized name in lilac. */
export function toolStyle(name: string): ToolStyle {
  return TOOLS[name] ?? { label: name.replace(/_/g, ' '), icon: Wrench, tone: HIGHLIGHTERS.lilac };
}

/** Tools whose results change notes, so the notes cache must refetch. */
const NOTE_MUTATING = new Set(['annotate_note', 'remove_note_annotations']);

export function changesNotes(name: string): boolean {
  return NOTE_MUTATING.has(name);
}
